import { subscribeChannel, publishChannel } from './channelUtils';

export function sendPosition(position) {
    
    publishChannel('trip-position-analysis-upsert', position);

}

export function sendPositionsBatch(positions) {
    
    publishChannel('trip-position-analysis-batch-upsert', positions);

}

export function sendDeletePosition({ date, codigo }) {
    
    publishChannel('trip-position-analysis-delete', { date, codigo });

}

export function listenTripPositionsAnalysis(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'trip-position-analysis-upsert' &&
            tipo !== 'trip-position-analysis-batch-upsert' &&
            tipo !== 'trip-position-analysis-delete'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}